export default __webpack_public_path__ + "locales/hy-AM/Settings.json?hash=ab60c31328e96237938136f8f0ce9600";